import { FiHeart } from 'react-icons/fi'
import { Container, Reveal, RevealGroup } from '@/components/common'
import { orgValues, pillars } from '@/constants/mission-vision'

export const MissionVision = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Purpose, vision, and the <span className="text-ibon-dark/30">values we live by.</span>
            </h2>
          </Reveal>
        </div>

        <RevealGroup className="mt-16 grid gap-px overflow-hidden border border-border bg-border lg:grid-cols-3">
          {pillars.map(({ no, label, title, description, Icon }) => (
            <article
              key={no}
              className="group bg-white p-8 transition-colors hover:bg-surface lg:p-10"
            >
              <Icon className="text-3xl text-ibon-dark transition-colors duration-300 group-hover:text-ibon-sky" />
              <p className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-sky">
                {label}
              </p>
              <h3 className="mt-3 text-2xl font-bold leading-tight tracking-tight text-ibon-dark sm:text-3xl">
                {title}
              </h3>
              <p className="mt-5 text-base leading-relaxed text-text-muted">{description}</p>
            </article>
          ))}

          <article className="group bg-ibon-dark p-8 lg:p-10">
            <FiHeart className="text-3xl text-ibon-sky" />
            <p className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-sky">
              Our Values
            </p>
            <ul className="mt-5 space-y-5">
              {orgValues.map(({ name, detail }) => (
                <li key={name}>
                  <p className="text-lg font-bold tracking-tight text-white">{name}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/60">{detail}</p>
                </li>
              ))}
            </ul>
          </article>
        </RevealGroup>
      </Container>
    </section>
  )
}
